export const RoutesPath = {
  Employees: '/employees',
  Login: '/login',
  NoAccess: '/no-access',
  OAuthCallback: '/:provider/auth/callback',
  Profile: '/profile',
  Projects: '/projects',
  TechWorks: '/techworks',
  TestEdit: '/test/:idOrAlias',
  TestStatsPage: '/test/stats/:idOrAlias',
  Tests: '/tests',
};
